module.exports = __webpack_public_path__ + "img/red-minus.7da31721.svg";